import axios from "axios"
import { GetListPublicParamsType } from "../../types/common/commonTypes";
import Urls from "../endpoints";
import { IEditActiveProductsObj } from "../modelAPI/activePackage";
import { IEditActivePackage } from "../resultAPI/activePackage";


export const getActiveProducts = (params: GetListPublicParamsType) => {
    return axios.post(Urls.GetActiveProducts(),params)
}

export const editProductPrice = (params: IEditActiveProductsObj) => {
    return axios.post<IEditActivePackage>(Urls.EditProductPrice(), params)
}
